import React from 'react';
import { Panel, Empty } from '../../components/Primitives';
import { useFetch } from '../../lib/hooks';
import { fmtDate } from '../../lib/api';

export default function AdminAuditLogs() {
  const { data: logs } = useFetch('/admin/audit-logs', [], 30000);
  return (
    <div data-testid="admin-audit-logs">
      <Panel title="Audit Logs">
        {logs && logs.length ? (
          <div className="overflow-x-auto"><table className="w-full text-sm">
            <thead><tr className="text-left text-xs text-vj-grey border-b border-border"><th className="py-2 font-medium">Event</th><th className="font-medium">Actor</th><th className="font-medium">Action</th><th className="font-medium">Target</th><th className="font-medium">Time</th></tr></thead>
            <tbody>{logs.map((l, i) => (
              <tr key={i} className="border-b border-border last:border-0">
                <td className="py-2.5 font-mono text-xs text-vj-grey">{l.event_id}</td>
                <td className="text-xs">{l.actor_email}</td>
                <td className="text-xs text-vj-neon">{l.action}</td>
                <td className="font-mono text-xs text-vj-grey truncate max-w-[160px]">{l.target || '—'}</td>
                <td className="text-xs text-vj-grey">{fmtDate(l.timestamp)}</td>
              </tr>
            ))}</tbody>
          </table></div>
        ) : <Empty>No audit events yet.</Empty>}
      </Panel>
    </div>
  );
}
